import { hookstate } from "@hookstate/core";
import { ISimulacaoState } from "./simulacao";
import { IPassoSeguroState } from "./pages/seguro/passo-seguro";
import { IPassoContratacaoState } from "./pages/seguro/passo-contracao";
import { IPageCertificadoState } from "./pages/certificado/certificado";

export const globalState = hookstate({
    isLoading: true
} as {
    isLoading: boolean,
    simulacao: ISimulacaoState
    passoSeguro: IPassoSeguroState
    passoContracao: IPassoContratacaoState
    pageCertificado: IPageCertificadoState
});